module.exports = __webpack_public_path__ + "static/media/Strategicpartners.75fbb8b8.gif";